import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react'
import { ReactNode } from 'react'
import { cn } from 'utils/classnames'
import ArrowDown from '../public/icons/accordian-arrow.svg'

interface AccordianProps {
  titleContent: string | ReactNode
  children: ReactNode
  className?: string
  buttonClass?: string
  panelClass?: string
  defaultOpen?: boolean
}

const Accordian = ({
  className,
  titleContent,
  children,
  buttonClass,
  panelClass,
  defaultOpen = false,
}: AccordianProps) => {
  return (
    <Disclosure defaultOpen={defaultOpen}>
      {({ open }) => (
        <div className={className}>
          <div
            className={cn(
              'flex w-full items-center justify-between border-b border-th-input-border py-2',
              buttonClass,
              open && 'border-b-0',
            )}
          >
            <div className="flex-1 text-base font-medium text-th-fgd-1">
              {titleContent}
            </div>

            <DisclosureButton
              className="cursor-pointer"
              onClick={(e) => e.stopPropagation()}
            >
              <ArrowDown
                width={24}
                height={24}
                className={cn(open ? 'rotate-180 text-th-active' : 'rotate-0')}
              />
            </DisclosureButton>
          </div>

          <DisclosurePanel
            className={cn('border-b border-th-input-border py-2', panelClass)}
          >
            {children}
          </DisclosurePanel>
        </div>
      )}
    </Disclosure>
  )
}

export default Accordian
